"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class AlertStatusController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/alertStatus',
            edit: '/v1/alertStatus/:objectId',
            delete: '/v1/alertStatus/:objectId',
        };
    }
}
exports.default = AlertStatusController;
